import React, { useState } from 'react';
// Ensure this import path matches your CSS file name and location
import './EmailAddress.scss';
// Import the SVG icon
import copyIcon from "../assets/copyIcon.svg";


export default function EmailAddress() {
    const emailAddress = 'info@satyress.com';
    const [copySuccess, setCopySuccess] = useState(''); // State to manage feedback message

    // Function to handle copying the email address
    const copyToClipboard = async () => {
      try {
        await navigator.clipboard.writeText(emailAddress);
        setCopySuccess('Copied!'); // Set success message
        // Reset message after a short delay
        setTimeout(() => setCopySuccess(''), 1500);
      } catch (err) {
        setCopySuccess('Failed to copy'); // Set error message
        console.error('Failed to copy text: ', err);
        setTimeout(() => setCopySuccess(''), 1500);
      }
    };

    // Removed isHovering state and related handlers (onMouseEnter/onMouseLeave)
    // as hover is handled by CSS :hover pseudo-class

    return (
      // Use the correct CSS class names as strings
      <div className='containerStyle'>
        <span>Contact us at:</span>
        <span className='emailStyle'>{emailAddress}</span>
        <button
          onClick={copyToClipboard}
          // Assign the className directly as a string
          className='buttonStyle' // Apply the button style class
          // Removed onMouseEnter/onMouseLeave
          aria-label={`Copy email address ${emailAddress}`} // Accessibility
        >
          {/* Use the imported SVG icon */}
          <img src={copyIcon} alt="Copy icon" className="copyIcon" /> {/* Added class for potential styling */}
        </button>
        {/* Display feedback message */}
        {copySuccess && <span className='copyFeedback'>{copySuccess}</span>}
      </div>
    );
  }
